var _path, _rect, _path2, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyAnnotationsIcon = function SvgEmptyAnnotationsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 61,
    fill: "none",
    viewBox: "0 0 71 61"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5FE",
    d: "M32.5 28.405a1 1 0 0 1-1.09.996l-3.56-.324a1 1 0 0 1-.907-.93l-.366-5.487a1 1 0 0 1 1.081-1.064l3.925.328a1 1 0 0 1 .917.996z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32.28,
    height: 16.68,
    x: 0.5,
    y: 21.5,
    stroke: "#5F677E",
    rx: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5FE",
    d: "M61 51a2 2 0 0 1-2 2h-2V22h2a2 2 0 0 1 2 2zM53 2a2 2 0 0 1 2-2h2v17h-2a2 2 0 0 1-2-2zM18 45a2 2 0 0 1 2-2h3v17h-3a2 2 0 0 1-2-2z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    x: 26.5,
    y: 6.5,
    stroke: "#5F677E",
    rx: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    x: 53.5,
    y: 0.5,
    stroke: "#5F677E",
    rx: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 32.28,
    height: 16.68,
    x: 49.78,
    y: 60.18,
    stroke: "#5F677E",
    rx: 2.5,
    transform: "rotate(-180 49.78 60.18)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 32.28,
    height: 16.68,
    x: 61.18,
    y: 21.5,
    stroke: "#5F677E",
    rx: 2.5,
    transform: "rotate(90 61.18 21.5)"
  })));
};
export default SvgEmptyAnnotationsIcon;